module.exports = __webpack_public_path__ + "static/videoFormContact-4e0fe8f5f360b71d07a86d0a3d315737.mp4";